import { useEffect } from 'react'
import { inject, observer } from 'mobx-react'
import { withRouterProps } from '../../utils'

// Overall Strategy now exists only in spend-down flows; redirect all other users to Home.
function Overall(props) {
  const {
    config: { isSpendown, spendDownModeling },
  } = props.store

  useEffect(() => {
    props.navigate(isSpendown || spendDownModeling ? '/spending' : '/home', { replace: true })
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  return null
}

export default withRouterProps(inject('store')(observer(Overall)))
